module.exports = __webpack_public_path__ + "img/personal-frontup.6f36d9b3.png";